import Marquee from "react-fast-marquee";

const items = [
  "GLOBAL ITAD",
  "70+ COUNTRIES",
  "SECURE DATA DESTRUCTION",
  "NIST 800-88",
  "DATA CENTER DECOMMISSIONING",
  "CIRCULAR ECONOMY",
  "SINGLE POINT OF CONTACT",
];

export default function EditorialMarquee() {
  return (
    <section className="bg-[#0a0a0a] py-8 md:py-10 overflow-hidden border-y border-white/10" data-testid="editorial-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-black uppercase tracking-tight text-4xl md:text-6xl text-transparent [-webkit-text-stroke:1.5px_#f7f7f6] px-6 md:px-10">
              {t}
            </span>
            <span className="h-3 w-3 bg-primary rotate-45" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
